/**
 * The column pickers' note for sources whose columns are not known (a CTE, a
 * derived table, a table function, a table missing from the schema cache):
 * the whole empty-state message when nothing is listable, else a footer note
 * under the tables that are.
 */

import type { QuerySource } from '../../../../sql-resolver/scope/querySources';
import { vqeCopy } from '../../ux/vqeCopy';

const KIND_LABEL: Record<QuerySource['kind'], string> = {
  cte: vqeCopy.picker.sourceKindCte,
  derived: vqeCopy.picker.sourceKindDerived,
  function: vqeCopy.picker.sourceKindFunction,
  relation: vqeCopy.picker.sourceKindUncached,
};

export function unresolvedSourcesCopy(
  unresolved: readonly QuerySource[],
  hasListedColumns: boolean,
): { readonly emptyMessage?: string; readonly notice?: string } {
  if (unresolved.length === 0) return {};
  const names = unresolved.map((s) => `${s.exposedName} (${KIND_LABEL[s.kind]})`).join(', ');
  return hasListedColumns
    ? { notice: vqeCopy.picker.columnsNotListed(names) }
    : { emptyMessage: vqeCopy.picker.columnsUnknown(names) };
}
